/**
 * Gets a cookie value by name
 * @param cookieName - The name of the cookie to retrieve
 * @returns The cookie value as a string, boolean (if value is "true" or "false"), or null if not found
 */
const getCookie = (cookieName: string): string | boolean | null => {
  const cookies = document.cookie;
  const cookiePrefix = `${cookieName}=`;

  const cookieIndex = cookies.indexOf(cookiePrefix);
  if (cookieIndex === -1) return null;

  let cookieValueIndex = cookies.indexOf(";", cookieIndex);
  if (cookieValueIndex === -1) cookieValueIndex = cookies.length;

  const valor = decodeURIComponent(cookies.substring(cookieIndex + cookiePrefix.length, cookieValueIndex));

  if (valor === "true") {
    return true;
  } else if (valor === "false") {
    return false;
  }

  return valor;
};

export default getCookie;
